const HEADER_MOD = {
  'Can your service agents monitor and access data from your Internet of Things (IoT)-connected assets within a single application to speed issue resolution?': {
    header: 'REMOTE MONITORING',
    negCopy:
      'Omni-channel customer service lets you manage service requests, including those auto-generated by IoT-enabled assets, in a single view.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are customers able to troubleshoot service issues through self-serve, automated digital tools?': {
    header: 'CUSTOMER SELF-SERVICE',
    negCopy: 'Self-service automation enables customers to resolve issues on their own terms, reduces service costs, and lightens the load on agents.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you automatically create a work order and schedule a field service event based on data from IoT-enabled devices?':
    {
      header: 'INTELLIGENT WORK ORDER CREATION',
      negCopy:
        'Use IoT-connected asset data to predict when your customers need help so you can offer service at the right time and in the right place.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you offer customers a configurable portal to log in and get real time status and other relevant information about their assets?': {
    header: 'CUSTOMER PORTAL',
    negCopy:
      'Customer portals extend the relationship between the customer and the vendor beyond the product purchase or equipment install.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your contact center agents have a 360-degree view of your customer, including account information, installed asset data, as well as order and service history?':
    {
      header: 'CONTACT CENTER',
      negCopy:
        'Connect your customer, asset, service history, and other relevant data with operational systems in finance and supply chain to deliver consistent, personalized experiences throughout the service lifecycle.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can you automate customer notifications indicating a service disruption may occur or has already occurred?': {
    header: 'CUSTOMER COMMUNICATION',
    negCopy:
      'Automatically prompt customers to schedule service or offer guided self-repair actions to prevent or mitigate downtime.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you provide AI-prescribed next-best action recommendations to your service agents during customer service engagements?': {
    header: 'AGENT ENABLEMENT',
    negCopy:
      'Using data to predict the next-best steps to take with your customers can guide agents to help them resolve issues more quickly.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you support SMS, chatbots, social, and other messaging channels customers prefer to use today?': {
    header: 'OMNI-CHANNEL SERVICE',
    negCopy: 'Allow customers to get help anytime, anywhere, through any channel they prefer, including digital, social, messaging, and mobile.',
    negLink: '',
    negLinkTxt: '',
  },
  'How would you rate your ability to manage unplanned or emergency service events?':
    {
      header: 'UNPLANNED ACTIVITY SCHEDULING',
      negCopy:
        'Top performing field service teams can automatically adjust schedules when the unexpected happens without disrupting other customers or adding expensive overtime.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can you automate and optimize the scheduling and routing of any type of work, including urgent and emergency work, with no need for human intervention?': {
    header: 'OPTIMIZED SERVICE SCHEDULING',
    negCopy:
      'Organizations using schedule automation tools can reduce unproductive activities by 15% or more, both for technicians and dispatchers.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your field service teams have access to knowledge articles and guides on their mobile device?':
    {
      header: 'FIELD TECHNICIAN ENABLEMENT',
      negCopy: 'Preserving and sharing best practices helps turn regional best practices and anecdotal learnings into community knowledge. ',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your field teams use guided repair flows and video collaboration to get expert support?':
    {
      header: 'COLLABORATION',
      negCopy:
        'Letting junior technicians and service workers tap into more experienced technicians’ knowledge while on a job can turn a failed service visit into a successful resolution.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you support a Bring Your Own Device (BYOD) environment where field service teams can use any device to access job details and perform work?':
    {
      header: 'ONBOARDING',
      negCopy:
        'Easily onboard and send jobs to employees, subcontractors, and third-party service providers on their personal devices.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your customers track their on-site service events to see who is coming and when they will arrive?': {
    header: 'CUSTOMER EXPERIENCE',
    negCopy:
      'Companies like Uber and Lyft have raised customer expectations for field service. Customers expect field service organizations to provide a similar experience with tools that enable real-time visibility into service events.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do field technicians have a 360-degree view of your customer, including account information, installed asset data, as well as order and service history?': {
    header: 'DATA UNIFICATION',
    negCopy: 'The field service team of the present and the future will need to tap into a broad base of up-to-date, relevant, and on-demand data on the asset, equipment, and customer to resolve issues.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are you able to monitor and track route compliance, worker safety protocols, and other regulatory requirements?': {
    header: 'SAFETY & COMPLIANCE',
    negCopy: 'Field service technician safety is of paramount concern, and enabling automated notifications, checklists, or forms can ensure your teams are protected and compliant.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you easily receive, repair, & return customer assets?':
    {
      header: 'DEPOT REPAIR',
      negCopy:
        'Depot repair focuses on streamlining and automating the end-to-end repair process, from initiating a customer service request to delivering the repaired product back to the customer.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can service agents and field service technicians search for and order parts from a single application to better serve customers?': {
    header: 'PARTS LOOKUP AND ORDERING',
    negCopy:
      'Enabling your service teams to check part availability and order parts from contact center or field service applications speeds time to resolution.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you assign all labor and parts usage to a project for billing and costing?': {
    header: 'PROJECT MANAGEMENT',
    negCopy: 'Ensuring service costs are properly captured, recorded, and analyzed helps drive profitability improvements and service efficiency.',
    negLink: '',
    negLinkTxt: '',
  },
  'What percentage of service revenue do your spare parts and logistics costs equal?':{
      header: 'PARTS AND LOGISTICS COSTS',
      negCopy:
        'Spare parts represent the single largest investment and second-largest expense when running a product service business.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your service team generate a customer invoice for labor and spare parts used from their mobile device?': {
    header: 'CUSTOMER DEBRIEF AND BILLING',
    negCopy: 'Track material and labor costs throughout the entire lifecycle of the work order and enable service team members to review and capture approval from customers on-site to improve speed-to-cash.',
    negLink: '',
    negLinkTxt: '',
  },
  'Are customers able to search and order from your parts inventory or configure and order custom parts for their installed assets?': {
    header: 'CUSTOMER SELF-SERVICE  ',
    negCopy:
      'Simplify the configuration and ordering of parts and services using an intuitive, visual user experience to reduce customer effort and improve time to resolution.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you dispatch a field service technician who has the right part in their trunk stock or a nearby warehouse?':
    {
      header: 'FIELD SERVICE COORDINATION',
      negCopy:
        'Ensure “one and done” service calls by matching technician skills, schedules, and parts availability to service requests.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your field service teams locate and source parts or tools on other service vehicles and from nearby warehouses in the area needed to complete an active service request?': {
    header: 'FIELD SERVICE ENABLEMENT',
    negCopy:
      'When field service resources can locate required parts nearby, first time fix rates improve as well as customer satisfaction scores',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your field service teams have real-time visibility into which entitlements are covered as part of a customer’s subscription?': {
    header: 'SERVICE ENTITLEMENTS',
    negCopy:
      'Entitlement visibility allows field service technicians to accurately apply price lists and discounts to work orders for parts and services.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can you easily apply contract discounts to ensure accurate invoicing?':
    {
      header: 'SERVICE PRICING ADJUSTMENTS',
      negCopy:
        'Automate billing processes and ensure the appropriate price list and entitlements are applied by connecting service and billing applications.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do you have up-to-date and accurate information about your customer’s assets, including associated contracts/warranties?':
    {
      header: 'ASSET MANAGEMENT',
      negCopy:
        'Connecting asset management data to all applications in the service lifecycle reduces friction, speeds resolution, and improves efficiency.',
      negLink: '',
      negLinkTxt: '',
    },
    'Are you able to automate the end-to-end process of claims management?':
    {
      header: 'WARRANTY MANAGEMENT',
      negCopy:
        'Warranty management automates the end-to-end process of claims management that includes registration, claim capture, claims validation, parts returns, and extended warranty service.',
      negLink: '',
      negLinkTxt: '',
    },
    'Do your field service teams have real-time visibility into which entitlements are covered as part of a customer’s subscription?':
    {
      header: 'SERVICE ENTITLEMENTS',
      negCopy:
        'Entitlement visibility allows field service technicians to accurately apply price lists and discounts to work orders for parts and services.',
      negLink: '',
      negLinkTxt: '',
    },
  'Are you able to define, schedule, and execute proactive maintenance service activities?':
    {
      header: 'PROACTIVE SERVICE',
      negCopy:
        'Achieving substantial improvements through proactive service requires the combined implementation of IoT-enabled solutions and supporting services.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can you coordinate the delivery of relevant, personalized offers to customers during service events?':
    {
      header: 'OFFERS AND PROMOTIONS',
      negCopy:
        'Delivering offers during service events can have a significant impact on revenue growth, including upsells and renewals.',
      negLink: '',
      negLinkTxt: '',
    },
  'Do your service teams receive training to identify sales opportunities and complete transactions during service events?':
    {
      header: 'SALES TRAINING',
      negCopy:
        'Drive incremental growth by investing the time and resources in sales competency training for your service teams.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your service teams initiate or renew bundled service contracts or subscriptions during customer engagements?':
    {
      header: 'SUBSCRIPTIONS AND RENEWALS',
      negCopy:
        'Protect and grow revenues by empowering trusted advisors such as service agents or field technicians to capture subscription agreements or renewals during customer service engagements.',
      negLink: '',
      negLinkTxt: '',
    },
  'Can your service teams review and track the status of their sales-related commissions and compensation?': {
    header: 'SALES COMPENSATION',
    negCopy: 'When service teams can track their sales compensation they are energized and incentivized to generate more revenue during service activities.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do your service teams have the insights and tools to generate revenue from service interactions?': {
    header: 'SALES ENABLEMENT',
    negCopy:
      'When it comes to driving incremental growth from existing contracts and existing buyers, there may be no better team to drive these opportunities than your service organization.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can your field service teams build quotes and complete sales in the field?': {
    header: 'ORDER QUOTING',
    negCopy: 'Enabling field service technicians to build quotes and capture customer approval streamlines your administration process so you can concentrate on satisfying your customers.',
    negLink: '',
    negLinkTxt: '',
  },
  'Do you offer customers a way to subscribe to or renew service packages themselves?': {
    header: 'CUSTOMER SELF-SERVICE  ',
    negCopy: 'Giving customers a frictionless subscription and renewal process is a low-effort initiative that can protect predictable revenue streams.',
    negLink: '',
    negLinkTxt: '',
  },
  'Can your service teams generate a customer invoice for subscription renewals on their mobile device?': {
    header: 'CUSTOMER DEBRIEF & BILLING ',
    negCopy:
      'Enabling service teams to capture subscription agreements or renewals and generate invoices speeds revenue recognition and reduces friction.',
    negLink: '',
    negLinkTxt: '',
  },
};
export default HEADER_MOD;
